import { LoginResourcePackage } from "../../resources/LoginResourcePackage";
import { BaseLoginButton } from "./BaseLoginButton";

export class PasskeyLoginButton extends BaseLoginButton {
    private static readonly BUTTON_TEXT = "CONNECT WITH PASSKEY";

    public constructor(loginResources: LoginResourcePackage) {
        super(
            loginResources.assets_views_login_buttons_button_blue_big_png,
            loginResources.assets_views_login_buttons_passkey_icon_png,
            PasskeyLoginButton.BUTTON_TEXT
        );
    }
}
